export default __webpack_public_path__ + "static/media/ceo_img.cb434280.png";